
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import { DataTableHeaders, DataTableHeaderType } from '@/types';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';
    import StudienDetail from '@/components/Studien/StudienDetail.vue';
    import Studie from '@/types/Studie';

    @Component({
        components: {
            StudienDetail,
        },
        computed: {
            ...mapState('studien', ['studien', 'dialogs', 'loaders']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('studien', ['loadStudien']),
            ...mapMutations('studien', ['setDialogsDetail']),
        },
    })
    export default class Studien extends Vue {
        public studie = new Studie();
        public search = '';

        public loadStudien!: () => void;
        public setDialogsDetail!: (visible: boolean) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public get headers(): DataTableHeaders<Studie> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Bezeichnung', value: 'bezeichnung' },
                { text: 'Gültig', value: 'gueltig' },
            ].filter((header) => header) as DataTableHeaders<Studie>;
        }

        public mounted(): void {
            this.loadStudien();
        }

        public onClickEdit(studie: Studie): void {
            this.studie = new Studie(studie);
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.studie = new Studie();
            this.setDialogsDetail(true);
        }
    }
